import React from 'react';
import { NavLink } from 'react-router-dom';
import { Compass, Search, BookHeart, Calendar, User } from 'lucide-react';

// Mobile bottom nav per shared-docs/frontend-architecture.md: fixed bottom-0 z-30
// md:hidden safe-area-bottom, height 16 (touch target). Hidden on desktop where the
// fixed sidebar takes over.
export default function BottomNav() {
  const navItems = [
    { to: '/', icon: Compass, label: 'Explore' },
    { to: '/browse', icon: Search, label: 'Browse' },
    { to: '/cookbook', icon: BookHeart, label: 'Cookbook' },
    { to: '/meal-plan', icon: Calendar, label: 'Plan' },
    { to: '/profile', icon: User, label: 'Profile' },
  ];

  return (
    <nav
      role="navigation"
      aria-label="Primary"
      className="fixed bottom-0 left-0 right-0 z-30 md:hidden safe-area-bottom bg-white dark:bg-night-surface border-t border-gray-100 dark:border-night-card"
    >
      <div className="grid grid-cols-5 h-16">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              [
                'flex flex-col items-center justify-center gap-1 text-xs transition-colors',
                isActive
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-gray-500 dark:text-night-muted hover:text-gray-700 dark:hover:text-night-text',
              ].join(' ')
            }
          >
            <Icon size={22} aria-hidden="true" />
            <span className="leading-none">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
